module.exports = __webpack_public_path__ + "assets/img/share_list_your_car_graphic.3e641025.png";